import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sl_token";

// sessionStorage persists across page refreshes within the same tab, but is
// cleared the moment the browser/tab is closed. Matches the user's expectation:
// "if I close the browser I should be logged out".
export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(t) {
  try {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
    // Also wipe any legacy localStorage tokens from before this change.
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
  } catch {
    // ignore
  }
}

export const api = axios.create({
  baseURL: API,
  // We use Bearer tokens via the Authorization header (set in the request
  // interceptor below), NOT cookies. Setting withCredentials triggers strict
  // CORS rules that cause error responses (e.g. 401 on wrong password) to be
  // hidden from JS as a generic "Network Error".
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
